import initializeBootLocalization from 'mini-boot-localization/lib/initializeBootLocalization';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import initializeDateTime from 'owa-shared-bootstrap/lib/initializeDateTime';
import {
    getUserFastBootSettings,
    saveUserFastBootSettingsUsingSessionData,
} from './userFastBootSettingsUtils';
import { SessionData } from 'owa-service/lib/types/SessionData';
import setUserConfiguration from 'owa-session-store/lib/actions/setUserConfiguration';
import { measureFunctionPerf } from 'mini-performance/lib/utils/measureFunctionPerf';

export async function earlyProcessingForMini(
    workload: OwaWorkload,
    sessionDataPromise: Promise<SessionData>
) {
    const fastBootSettings = getUserFastBootSettings();
    saveUserFastBootSettingsUsingSessionData(sessionDataPromise);

    // Early processing can only be attempted if the userfastbootsettings are found.
    if (!fastBootSettings) {
        return;
    }

    const trackFn = measureFunctionPerf(executeEarlyProcessing, 'earlyprocessing');
    trackFn(fastBootSettings, workload);
}

async function executeEarlyProcessing(fastBootSettings: any, workload: OwaWorkload) {
    // This line is required as initializeDateTime now does not take user config and it returns a promise on which
    // the bootstrapping awaits.
    setUserConfiguration({ UserOptions: fastBootSettings });
    initializeDateTime(false /** Should Initialize Timezone Anonymously */);

    const language = fastBootSettings.language;
    language && (await initializeBootLocalization(workload)(language));
}
